import { Button, Col, Collapse, Divider, Form, Input, Row } from 'antd';
import { FC, Fragment } from 'react';
import FBDHSiteVisitReportAttendee from './VisitReportApproval.Site.Attendee';
import FBDHSiteVisitReportDetail, {
	useFBDHSiteVisitReportDetailForm,
} from './VisitReportApproval.Site.Detail';
import FBDHSiteVisitReportUnit from './VisitReportApproval.Site.Unit';
import FBDHSiteVisitReportActivity from './VisitReportApproval.Site.Activity';
import FleetTitle from '@/libs/antd/components/Title';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { SiteReport } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';
import FBDHSiteVisitReportPhoto from './VisitReportApproval.Site.Photo';

const FBDHVisitReportApprovalSite: FC<{
	onNext: () => void;
}> = ({ onNext }) => {
	const detailForm = useFBDHSiteVisitReportDetailForm();
	const { siteReport } = useFBDHVisitReportApprovalPage();

	return (
		<Fragment>
			<Collapse
				defaultActiveKey={[]}
				items={[
					{
						key: 'visit',
						label: 'Detail Kunjungan',
						children: (
							<Fragment>
								<FBDHSiteVisitReportAttendee />
								<FBDHSiteVisitReportDetail />
								<Divider />

								<Row gutter={[20, 20]}>
									<Col span={6}>
										<strong>FRM Notes</strong>
									</Col>
									<Col span={18}>{siteReport?.additionalVisitInfo ?? '-'}</Col>

									<Col span={6}>
										<strong>CCA Notes</strong>
									</Col>
									<Col span={18}>
										{siteReport?.visitDetail.visitVerificationNotes ?? '-'}
									</Col>
								</Row>
							</Fragment>
						),
					},
					{
						key: 'unit',
						label: 'Analisa Unit',
						children: (
							<Fragment>
								<FBDHSiteVisitReportUnit />
								<Divider />

								<Row gutter={[20, 20]}>
									<Col span={6}>
										<strong>FRM Notes</strong>
									</Col>
									<Col span={18}>{siteReport?.additionalUnitInfo ?? '-'}</Col>

									<Col span={6}>
										<strong>CCA Notes</strong>
									</Col>
									<Col span={18}>
										{siteReport?.unitAnalysis.unitVerificationNotes ?? '-'}
									</Col>
								</Row>
							</Fragment>
						),
					},
					{
						key: 'activity',
						label: 'Aktivitas Usaha',
						children: (
							<Fragment>
								<FBDHSiteVisitReportActivity />
								<Divider />

								<Row gutter={[20, 20]}>
									<Col span={6}>
										<strong>FRM Notes</strong>
									</Col>
									<Col span={18}>
										{siteReport?.additionalBusinessActivityInfo ?? '-'}
									</Col>

									<Col span={6}>
										<strong>CCA Notes</strong>
									</Col>
									<Col span={18}>
										{siteReport?.businessActivity
											.businessActivityVerificationNotes ?? '-'}
									</Col>
								</Row>
							</Fragment>
						),
					},
				]}
			/>

			<FleetTitle>Action Plan</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				name="siteReport"
				form={detailForm.form}
				style={{ marginBottom: 20 }}
				initialValues={
					{
						actionPlan: siteReport.actionPlan,
					} as SiteReport<'payload'>
				}
			>
				<Form.Item name={detailForm.fieldName('actionPlan')}>
					<Input.TextArea
						rows={4}
						disabled
					/>
				</Form.Item>
			</Form>

			<FBDHSiteVisitReportPhoto />

			<Button
				type="primary"
				style={{
					width: 200,
					display: 'block',
					marginLeft: 'auto',
					marginTop: 20,
				}}
				onClick={() => {
					onNext?.();
				}}
			>
				NEXT
			</Button>
		</Fragment>
	);
};

export default FBDHVisitReportApprovalSite;
